var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.8 11.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94,8.15A3.28,3.28,0,0,1,4.3,6.83.7.7,0,1,1,5.42,6a1.92,1.92,0,0,0,2.66.38l.21-.18L9.84,4.64a1.9,1.9,0,0,0,.1-2.7,1.84,1.84,0,0,0-1.32-.6,2,2,0,0,0-1.36.51l-1,1a.7.7,0,0,1-1,0,.71.71,0,0,1,0-1L6.17,1,6.3.83A3.27,3.27,0,0,1,8.66-.06,3.33,3.33,0,0,1,11,1a3.31,3.31,0,0,1-.15,4.66L9.27,7.19a3.34,3.34,0,0,1-2.33,1ZM5.5,11l1-1a.71.71,0,0,0,0-1,.69.69,0,0,0-1,0l-1,1a1.9,1.9,0,0,1-2.69-.09,1.85,1.85,0,0,1-.51-1.36A1.9,1.9,0,0,1,2,7.15L3.52,5.59l.2-.18a1.93,1.93,0,0,1,1.41-.36,2,2,0,0,1,1.25.74A.7.7,0,1,0,7.5,5a3.3,3.3,0,0,0-4.62-.67c-.13.1-.24.2-.36.31L1,6.14A3.3,3.3,0,0,0,5.5,11Z",
    fill: "#456d86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.0f4c7db6c3f9841a7ad5cf6f13027811.svg";
export { ForwardRef as ReactComponent };